import { permissionCode } from "src/app/shared";
import { FeaturePermissionState } from "../permission.models";

export const taskFinderPermissionState: FeaturePermissionState = {
  view: [permissionCode.TASK_MANAGEMENT_TASK_FINDER_VIEW],
  edit: [permissionCode.TASK_MANAGEMENT_TASK_FINDER_EDIT],
};
